import { render, staticRenderFns } from "./PrintPreviewWithSideView.vue?vue&type=template&id=1f47d651"
import script from "./PrintPreviewWithSideView.vue?vue&type=script&lang=js"
export * from "./PrintPreviewWithSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f47d651')) {
      api.createRecord('1f47d651', component.options)
    } else {
      api.reload('1f47d651', component.options)
    }
    module.hot.accept("./PrintPreviewWithSideView.vue?vue&type=template&id=1f47d651", function () {
      api.rerender('1f47d651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printpreview/PrintPreviewWithSideView.vue"
export default component.exports